var map = {
	"./home/action.jpg": 7451,
	"./home/city.jpg": 224,
	"./home/energy.jpg": 2810,
	"./home/gentrification.jpg": 3673,
	"./home/industry.jpg": 1889,
	"./home/splashbackground.jpg": 9394,
	"./home/transport.jpg": 341,
	"./home/university.jpg": 3796,
	"./logo.png": 6949,
	"./pois": 5590,
	"./pois.json": 5590,
	"./stop2/bascom_hill.jpg": 1956,
	"./stop2/dairy_prod.png": 100,
	"./stop2/land_grab.png": 1265,
	"./stop2/plaque.jpg": 435,
	"./stop2/steenbock.jpg": 7673,
	"./stop2/title.jpg": 5650,
	"./stop3/burial_mounds.jpg": 5501,
	"./stop3/east_wash.jpg": 7708,
	"./stop3/flooding.jpg": 2620,
	"./stop3/holc_madison.jpg": 9590,
	"./stop3/madison.jpg": 199,
	"./stop3/madison_landforms.png": 2714,
	"./stop3/madison_streets.png": 6734,
	"./stop3/state_capitol.jpg": 639,
	"./stop3/title.jpg": 6641,
	"./stop4/badger_state.jpg": 8593,
	"./stop4/badger_state_modern.png": 202,
	"./stop4/industrial_map.jpg": 633,
	"./stop4/nike_map.png": 7913,
	"./stop4/protests.jpg": 8968,
	"./stop4/shoe_factories": 3488,
	"./stop4/shoe_factories.json": 3488,
	"./stop4/shoe_graph.jpg": 2919,
	"./stop4/shoe_legend.png": 3128,
	"./stop4/title.jpg": 9578,
	"./stop5/coal_plant.jpg": 379,
	"./stop5/emissions_map.png": 2494,
	"./stop5/pipeline_map.jpg": 5008,
	"./stop5/renewable_map.png": 2691,
	"./stop5/retaining_wall.jpg": 6096,
	"./stop5/title.jpg": 3401,
	"./stop5/windmills.jpg": 8272,
	"./stop6/aerial_1937.jpg": 6473,
	"./stop6/aerial_2020.jpg": 98,
	"./stop6/bike_path.jpg": 4315,
	"./stop6/pipeline_rail.jpg": 3346,
	"./stop6/station.jpg": 8222,
	"./stop6/title.jpg": 5530,
	"./stop7/act10.jpg": 9948,
	"./stop7/blm.jpg": 5367,
	"./stop7/capitol.jpg": 8386,
	"./stop7/murals.jpg": 9200,
	"./stop7/title.jpg": 2287,
	"./stop7/womens_march.jpg": 3590,
	"./stop8/hub.jpg": 8051,
	"./stop8/state_street_map.jpg": 8120,
	"./stop8/state_street_pic.jpg": 2039,
	"./stop8/title.jpg": 8672,
	"./stop8/university_inn.jpg": 4199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;